import React from 'react';
import { YourWorkItemListSkeleton } from '@atlassian/jira-skeletons/src/ui/your-work/YourWorkItemListSkeleton.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import {
	STARRED_TAB_KEY,
	SUCCESS_STATE,
	ERROR_STATE,
	EMPTY_STATE,
} from '../../../common/constants/tab-content.tsx';
import type { TabProps } from '../../../common/types/tabs.tsx';
import ErrorState from '../../../common/ui/error-state/index.tsx';
import ReloadingSpinner from '../../../common/ui/reloading-spinner/index.tsx';
import {
	EndInteractionsTracker,
	useFireErrorOrSuccessAnalytics,
	trimItemsBySection,
} from '../../../common/utils.tsx';
import ItemList from '../../../common/ui/item-list/index.tsx';
import EmptyState from './empty-state/index.tsx';

const StarredTab = (props: TabProps): React.JSX.Element => {
	const {
		itemProviderResult: { data, error, loading, reloading },
	} = props;

	const { appPermissions } = useTenantContext();

	useFireErrorOrSuccessAnalytics(!!data.total, error, loading, 'starred');

	if (error && !data.total) {
		return (
			<>
				<ErrorState />
				<EndInteractionsTracker transitionKey={STARRED_TAB_KEY} renderState={ERROR_STATE} />
			</>
		);
	}

	if (loading) {
		return <YourWorkItemListSkeleton />;
	}

	if (!data || !data.sections || data.sections.length === 0) {
		return (
			<>
				<EmptyState
					shouldShowBoardsLink={appPermissions && appPermissions.hasSoftwareAccess}
					shouldShowServiceDeskLink={appPermissions && appPermissions.hasServiceDeskAccess}
					shouldShowPlansLink={appPermissions && appPermissions.hasSoftwareAccess}
				/>
				<EndInteractionsTracker transitionKey={STARRED_TAB_KEY} renderState={EMPTY_STATE} />
			</>
		);
	}

	return (
		<>
			{reloading && <ReloadingSpinner />}
			<ItemList sections={trimItemsBySection(props.maxItems, data.sections)} showStar />
			<EndInteractionsTracker transitionKey={STARRED_TAB_KEY} renderState={SUCCESS_STATE} />
		</>
	);
};

export default StarredTab;
